import { useContext, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import WithClassName from './WithClassName';

function Size({ className }: WithClassName) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { facetData } = useContext(FacetDataContext);
  const [expand, setExpand] = useState(false);

  const show = appliedFilters.bodyStyles?.length ?? 0 > 0;

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-size"
        facetContent={facetData?.sizeClasses?.buckets}
        facetName="Size"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <CommonWrapper>
          {facetData?.sizeClasses?.buckets?.map(
            ({ count, displayName, key }) => (
              <Checkbox
                facet="sizeClasses"
                filter={key}
                id={`size-${key}`}
                key={key}
                label={
                  <LabelWithCount count={count} displayName={displayName} />
                }
                checked={appliedFilters.sizeClasses?.includes(key)}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'sizeClasses',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}

export default Size;
